import React from "react";
import { LockOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import { Input, Button } from "antd";
import FormItem from "antd/lib/form/FormItem";
import * as Sentry from "@sentry/react";
import AuthService from "../../Services/AuthService";

interface Props {
  changeState: (newState: string) => void;
  setError: (error: string) => void;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setUser: (user: any) => void;
  form: any;
  initialLoginType?: "Password";
}

interface State {
  loginType: "Password";
  loggingIn: boolean;
}

class SignIn extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loginType: "Password",
      loggingIn: false,
    };
  }
  setLoginType = (type: "Password"): void => {
    this.setState({
      loginType: type,
    });
  };
  loginWithPassword = (): void => {
    const { form } = this.props;
    this.setState({
      loggingIn: true,
    });
    form.validateFields(async (err: boolean, values: any) => {
      if (err) {
        this.setState({
          loggingIn: false,
        });
        return;
      }
      // Initiate Auth, and once we receive the challenge back, we can redirect the user
      const authService = new AuthService();
      try {
        const user = await authService.loginWithPassword(
          values.email,
          values.password
        );
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          this.props.setUser(user);
          this.props.setEmail(values.email);
          this.props.changeState("newPasswordRequired");
        }
      } catch (e) {
        if (e.code === "UserNotConfirmedException") {
          this.props.setEmail(values.email);
          this.props.setPassword(values.password);
          this.props.changeState("verificationCode");
          return;
        }
        Sentry.captureMessage(
          `Failed login for ${values.email}: ${JSON.stringify(e)}`
        );
        // Sentry.captureException(e);
        this.props.setError(e.message || "An error occurred");
        this.setState({
          loggingIn: false,
        });
      }
    });
  };
  goToSignup = (): void => {
    this.props.changeState("signUp");
  };
  handleKeyPress = () => {
    console.log("event");
    this.loginWithPassword();
  };
  render(): React.ReactElement {
    const { getFieldDecorator } = this.props.form;
    const { loggingIn } = this.state;
    return (
      <Form>
        <h2>Sign In</h2>
        <FormItem>
          {getFieldDecorator("email", {
            rules: [{ required: true, message: "Please input your email!" }],
          })(
            <Input placeholder="Email" />
          )}
        </FormItem>

        {this.state.loginType === "Password" && (
          <FormItem>
            {getFieldDecorator("password", {
              rules: [
                { required: true, message: "Please input your Password!" },
              ],
            })(
              <Input
                prefix={<LockOutlined style={{ fontSize: 13 }} />}
                type="password"
                placeholder="Password"
                onPressEnter={() => {
                  this.handleKeyPress();
                }}
              />
            )}
          </FormItem>
        )}

        <FormItem>
          {this.state.loginType === "Password" && (
            <>
              <Button
                disabled={loggingIn}
                type="link"
                className="login-form-forgot"
                onClick={(): void => this.props.changeState("forgotPassword")}
              >
                Forgot password
              </Button>
              <Button
                disabled={loggingIn}
                type="primary"
                onClick={(): void => this.loginWithPassword()}
                style={{ width: "100%" }}
                loading={this.state.loggingIn}
              >
                Log in
              </Button>
              <br />
              <br />
            </>
          )}
          {this.state.loginType !== "Password" && (
            <Button
              disabled={loggingIn}
              type="primary"
              onClick={(): void => this.setLoginType("Password")}
              style={{ width: "100%" }}
            >
              Log in
            </Button>
          )}
          {/*           
          Or{' '}
          <Button disabled={loggingIn} type="link" onClick={this.goToSignup}>
            register now!
          </Button> */}
        </FormItem>
      </Form>
    );
  }
}

const WrappedSignin = Form.create<Props>()(SignIn);

export default WrappedSignin;
